import React, { useMemo } from 'react';
import { Tooltip } from 'antd';
import { Info } from '../../assets/icons';
import './PropertyManage.scss';
import { useSelector } from 'react-redux';
import { PROPERTY_SUB_TYPE } from '../../utils/constant';
import { manageData, manageDataRented } from '../../pages/PropertyListing/IOVacationData';
import { singleManageData } from '../../pages/PropertyListing/IOSingleData';
import { multiManageData, multiManageDataRented } from '../../pages/PropertyListing/IOMultiData';
import { getDateFormat } from '../../utils';
import { getUsCurrencyFormat} from '../../utils/usCurrencyFormatter';

const PropertyManage = () => {
  const { data } = useSelector((state) => state.propertyDetails);

  const currentManageData = useMemo(() => {
    switch (data?.data?.propertyTypeName?.toLowerCase()) {
      case PROPERTY_SUB_TYPE.SINGLE?.toLowerCase():
        return singleManageData;
      case PROPERTY_SUB_TYPE.MULTI?.toLowerCase():
        return data?.data?.tenantStatus?.propertyStatus === 'rented' ? multiManageDataRented : multiManageData;
      default:
        return data?.data?.tenantStatus?.propertyStatus === 'rented' ? manageDataRented : manageData;
    }
  }, [data?.data?.propertyTypeName]);

  return (
    <div className='py-64 property-manage'>
      <p className='mb-32 fz-24 fw-700 lh-13'>{currentManageData.manageTitle}</p>
      <div className='manage-list'>
        {currentManageData.manageData.map((dataItem, index) => {
          let value = data?.data?.tenantStatus?.[dataItem.value];
          if (value && dataItem.formatDate) {
            const date = new Date(value);
            value = getDateFormat({
              date,
              options: {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                locales: 'en-US',
              },
            });
          }
          if (dataItem.map) {
            value = dataItem.map?.[data?.data?.tenantStatus?.[dataItem.value]];
          }
          if (dataItem.suffix) {
            if (dataItem?.suffix?.includes('%')) {
              value = getUsCurrencyFormat(Number(data?.data?.tenantStatus?.[dataItem.value]) || 0) + dataItem.suffix;
            } else {
              value = data?.data?.tenantStatus?.[dataItem.value] + dataItem.suffix;
            }
          }
          return (
            <div className='manage-list__item' key={index}>
              <Tooltip title={dataItem.tooltip}>
                <span className={dataItem.tooltip ? 'manage-list__item__label tooltip' : 'manage-list__item__label'}>
                  {dataItem.label} {dataItem.tooltip && <Info marginLeft='8px' verticalAlign='sub' />}
                </span>
              </Tooltip>
              <span className='manage-list__item__value'>{value}</span>
            </div>
          );
        })}
      </div>
      {/* TODO: Remove || after I get data from APIs */}

      {data?.data?.propertyTypeName === 'Vacation rental' ? (
        <>
          <p className='fw-600 mt-40 fz-18 mb-16'> {data?.data?.brokerName}</p>
          <p>{data?.data?.brokerDetail}</p>
        </>
      ) : (
        <>
          <p className='fw-600 mt-40 fz-18 mb-16'>{currentManageData.processTitle}</p>
          <p>
            {data?.data?.managementPartnerDesc}{' '}
            {/* <Link to='/' className='fw-600 underline text-terracotta'>
              Learn more
            </Link> */}
          </p>
        </>
      )
      }
    </div>
  );
};

export default PropertyManage;
